import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { Stacker } from "@/components/molecules/Stacker";
import CareerCover from "@/components/organisms/CareerCover";
import CareerEnvironment from "@/components/organisms/CareerEnvironment";
import CareerIdeal from "@/components/organisms/CareerIdeal";
import CareerMessage from "@/components/organisms/CareerMessage";
import CareerNav from "@/components/organisms/CareerNav";
import CareerPosition from "@/components/organisms/CareerPosition";
import CareerProcess from "@/components/organisms/CareerProcess";
import { CareersBnrLev } from "@/components/organisms/CareersBnrLev";
import Contact from "@/components/organisms/Contact";
import { VoiceNav } from "@/components/organisms/VoiceNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";

export default function CareerPage(props) {
  return (
    <>
      <Meta
        pageTitle={"キャリア・採用情報"}
        pageDescription={
          "株式会社トッカシステムズのキャリア・採用情報です。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/careers/"}
      />
      <Layout className="relative">
        <Header />
        <main className="z-10 flex-1">
          <Container>
            {/* <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Careers",
                },
              ]}
            /> */}
            <Inner className="max-w-full">
              <CareerCover />
              <Stacker>
                <CareerNav />
                <CareersBnrLev />
                <CareerMessage />
                <CareerIdeal />
                <VoiceNav />
                <CareerEnvironment />
                <CareerProcess />
                <CareerPosition />
                {/* <CareersBnrLev /> */}
              </Stacker>
            </Inner>
          </Container>
        </main>
        <Contact>
          ご応募や採用に関するお問い合わせ／ご連絡をお待ちしております。
          <br />
          まずはお気軽にお問い合わせください。
        </Contact>
        <Footer />
      </Layout>
    </>
  );
}
